export const SHOPPING_CART_DELIVERY_OPTION_LOAD_SEND_REQUEST =
    'SHOPPING_CART_DELIVERY_OPTION_LOAD_SEND_REQUEST';
export const SHOPPING_CART_DELIVERY_OPTION_LOAD_RECEIVE_RESPONSE =
    'SHOPPING_CART_DELIVERY_OPTION_LOAD_RECEIVE_RESPONSE';
export const SHOPPING_CART_DELIVERY_OPTION_LOAD_FAILED =
    'SHOPPING_CART_DELIVERY_OPTION_LOAD_FAILED';
export const SHOPPING_CART_DELIVERY_OPTION_SET =
    'SHOPPING_CART_DELIVERY_OPTION_SET';
